module.exports = __webpack_public_path__ + "static/media/item_location_changed.a20f9392.svg";